// Mock data for the Broer casino streamer community site.
// This will later be replaced by real data (e.g. Roobet affiliate API via backend).

export const REF_CODE = "BROER";
export const ROOBET_LINK = "https://roobet.com/?ref=BROER";

export const SOCIALS = {
  kick: "https://kick.com/maxwinbroer",
  discord: "https://discord.gg/s6u6QMvP2m",
  x: "https://X.com/MaxWinBroer",
  instagram: "https://instagram.com/maxwinbroer",
};

export const KICK_EMBED = "https://player.kick.com/maxwinbroer";

export const NAV_LINKS = [
  { label: "LEADERBOARD", href: "#leaderboard" },
  { label: "REWARDS", href: "#rewards" },
  { label: "VIP TRANSFER", href: "#vip-transfer" },
  { label: "SOCIALS", href: "#socials" },
];

// Monthly wager race: $500 total split across top 5
export const PRIZE_POOL = 500;
export const PRIZES = [200, 125, 85, 55, 35]; // sums to 500

export const LEADERBOARD = [
  { rank: 1, username: "MaxWin_Mike", wagered: 148920.55, prize: 200 },
  { rank: 2, username: "LuckyLars", wagered: 121340.10, prize: 125 },
  { rank: 3, username: "SpinnerSven", wagered: 98760.75, prize: 85 },
  { rank: 4, username: "RoyalRon", wagered: 74210.40, prize: 55 },
  { rank: 5, username: "BetBaasJ", wagered: 61890.20, prize: 35 },
  { rank: 6, username: "NightOwl92", wagered: 45120.00, prize: 0 },
  { rank: 7, username: "DuckDynasty", wagered: 38740.65, prize: 0 },
  { rank: 8, username: "GoldRush_NL", wagered: 31220.30, prize: 0 },
  { rank: 9, username: "VaultViper", wagered: 27810.90, prize: 0 },
  { rank: 10, username: "CashCarlo", wagered: 22450.15, prize: 0 },
];

// End of current month (used for the countdown timer)
export function getRaceEndDate() {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth() + 1, 1, 0, 0, 0);
}

export const PROMOS = [
  {
    id: "rakeback",
    image: "/assets/chest.png",
    title1: "INSTANT",
    title2: "RAKEBACK",
    bullets: [
      "Register on Roobet.com with code BROER",
      "Earn rakeback on every single wager",
      "Payouts sent instantly \u2014 no waiting",
    ],
    cta: "CLAIM ON ROOBET",
    ctaType: "roobet",
  },
  {
    id: "giveaways",
    image: "/assets/moneybag.png",
    title1: "COMMUNITY",
    title2: "GIVEAWAYS",
    bullets: [
      "Join the Broer Discord community",
      "Win tips for the best calls in chat",
      "Regular free drops & giveaways",
    ],
    cta: "JOIN DISCORD",
    ctaType: "discord",
  },
  {
    id: "guess",
    image: "/assets/safe.png",
    title1: "GUESS THE",
    title2: "BALANCE",
    bullets: [
      "Predict the end balance of a bonus hunt",
      "Closest guess takes the prize",
      "Play for free inside our Discord",
    ],
    cta: "PLAY IN DISCORD",
    ctaType: "discord",
  },
];

export const HOW_IT_WORKS = [
  {
    step: 1,
    title: "Sign Up With Code",
    desc: "Create your Roobet account using code BROER so your wagers count toward the race.",
  },
  {
    step: 2,
    title: "Play & Wager",
    desc: "Play your favourite slots and games. Every bet climbs you up the leaderboard.",
  },
  {
    step: 3,
    title: "Climb The Ranks",
    desc: "Track your position live on the leaderboard throughout the month.",
  },
  {
    step: 4,
    title: "Win Rewards",
    desc: "Finish top 5 at month's end and claim your share of the $500 prize pool.",
  },
];
